import { render, staticRenderFns } from "./RateLimit.vue?vue&type=template&id=55534541"
import script from "./RateLimit.vue?vue&type=script&lang=js"
export * from "./RateLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports